import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <>
    {/* Site Footer Start */}
    <footer id="th-contact" className="site-footer">
        {/* <div className="site-footer__shape-1 float-bob-y">
            <img src={Footershape} alt="" />
        </div>
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/">
                            <img src={footerLogo} alt="" />
                        </Link>
                    </div>
                    <div className="site-footer__social">
                        <Link to="#"><i className="icon-facebook"></i></Link>
                        <Link to="#"><i className="icon-fi"></i></Link>
                        <Link to="#"><i className="icon-instagram"></i></Link>
                        <Link to="#"><i className="icon-pinterest"></i></Link>
                    </div>
                </div>
            </div>
        </div> */}
        <React.Fragment>

          {/*Contact Two Start*/}
          <section className="contact-two">
            <div className="container">
              <div className="row">
                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-pin"></span>
                    </div>
                    <h3 className="contact-two__title">Location</h3>
                    <p className="contact-two__text">
                      Antipolo, Philippines
                    </p>
                  </div>
                </div>
                {/* Contact Two Single End */}

                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-paper-plan"></span>
                    </div>
                    <h3 className="contact-two__title">E-mail</h3>
                    <p className="contact-two__text">
                      <Link to="mailto:racketriotclub@gmail.com">
                        racketriotclub@gmail.com
                      </Link>
                    </p>
                  
                  </div>
                </div>
                {/* Contact Two Single End */}

                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-call"></span>
                    </div>
                    <h3 className="contact-two__title">Contact</h3>
                    <p className="contact-two__text">
                      <a href="tel:019457896332">09970985227</a>
                    </p>
                    
                  </div>
                </div>
                {/* Contact Two Single End */}
              </div>
            </div>
          </section>
          {/*Contact Two End*/}
        </React.Fragment>
        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© Do'IT 2025 | All Rights Reserved</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        {/* <li><Link to="/about">Terms & Condition</Link></li>  */}
                        <li><Link to="/privacy-policy.html" target="_blank">Privacy Policy</Link></li>
                        <li><Link to="/terms-of-service.html" target="_blank">Terms of Service</Link></li>
                        <li><Link to="#">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    {/* Site Footer End */}
    </>
  );
};

export default Footer;
